import { combineLatest, map, of } from 'rxjs';
import { memo } from '../util/index.js';
/**
 * @description Get the overall info for a society
 */
export function info(instanceId, api) {
  return memo(instanceId, () => combineLatest([api.query.society.bids(), api.query.society['defender'] ? api.query.society['defender']() : of(undefined), api.query.society.founder(), api.query.society.head(), api.query.society['maxMembers'] ? api.query.society['maxMembers']() : of(undefined), api.query.society.pot()]).pipe(map(_ref => {
    let [bids, defender, founder, head, maxMembers, pot] = _ref;
    return {
      bids,
      defender: defender === null || defender === void 0 ? void 0 : defender.unwrapOr(undefined),
      founder: founder.unwrapOr(undefined),
      hasDefender: (defender === null || defender === void 0 ? void 0 : defender.isSome) && head.isSome && !head.eq(defender) || false,
      head: head.unwrapOr(undefined),
      maxMembers,
      pot
    };
  })));
}